import { render } from "./MagicialView.vue?vue&type=template&id=a6013582&scoped=true"
import script from "./MagicialView.vue?vue&type=script&lang=js"
export * from "./MagicialView.vue?vue&type=script&lang=js"

import "./MagicialView.vue?vue&type=style&index=0&id=a6013582&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6013582"]])

export default __exports__